export const FIRST_RUN_STEPS = [
  {
    id: 'connect_skyslope',
    title: 'Connect SkySlope',
    description:
      'Paste your SkySlope Access Key and Access Secret in Settings. KeyFlo will automatically import your active files.',
    settingsTab: 'integrations',
  },
];

export const FIRST_RUN_ALTERNATIVE_STEPS = [
  {
    id: 'email_tc',
    title: 'Email tc@keyflo.ai',
    description: 'Forward the executed contract or listing agreement PDF to tc@keyflo.ai.',
    mailto: 'tc@keyflo.ai',
  },
  {
    id: 'portal_upload',
    title: 'Create in KeyFlo',
    description: 'Start a purchase agreement, listing, or buyer agreement in the portal.',
    action: 'create',
  },
];

export function skyslopeConnectComplete(tmsConfig) {
  return Boolean(
    tmsConfig?.tms_type === 'skyslope' && tmsConfig?.is_validated,
  );
}

export function inboundImportComplete(inboundStatus) {
  const status = (inboundStatus?.status || '').toLowerCase();
  return status === 'completed' || status === 'complete';
}

export function deriveFirstRunStepCompletion({ tmsConfig }) {
  return {
    connect_skyslope: skyslopeConnectComplete(tmsConfig),
    email_tc: false,
    portal_upload: false,
  };
}

export function shouldShowFirstRunChecklist({
  isTransactionGuest,
  profileCompleted,
  transactionCount,
}) {
  if (isTransactionGuest) {
    return false;
  }
  if (!profileCompleted) {
    return false;
  }
  return transactionCount <= 0;
}
